import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * VerifiedBadge — small blue check next to a vendor name.
 * Pass `size` ('sm' | 'md' | 'lg') for sizing.
 */
export default function VerifiedBadge({ verified, size = "sm", className = "" }) {
  if (!verified) return null;
  const sz = size === "lg" ? "w-5 h-5" : size === "md" ? "w-4 h-4" : "w-3.5 h-3.5";
  return (
    <BadgeCheck
      className={`${sz} text-cyan-400 fill-cyan-400/20 inline-block shrink-0 ${className}`}
      data-testid="verified-badge"
      aria-label="Verified vendor"
    />
  );
}
